exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/buzius/projects/easyflow-docker/workspace/easyflow/node_modules/css-loader?minimize!/home/buzius/projects/easyflow-docker/workspace/easyflow/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d97668f2","scoped":false,"hasInlineConfig":false}!/home/buzius/projects/easyflow-docker/workspace/easyflow/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 127
// module chunks = 0